export const LabelText = {
  ErrorBoundaryTitle: 'Something went wrong',
  ErrorBoundaryDescription: 'Reload this page or contact us at'
};
